export interface SiteProfileSettingsInterface {
	welcome_state: boolean,
	welcome_html: string
}

export class SiteProfileSettingsClass {
	welcome_state = true;
	welcome_html = '';
}
